export function ManufacturerIcon() {
  return (
    <svg width="48" height="44" viewBox="0 0 48 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14954_10810)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 0V44H0V27.6565L7.33508 15.8381L12.8874 24.7952L18.4398 15.8381L24 24.7952L29.5524 15.8381L35.1126 24.7952V0H48Z"
          fill="black"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_14954_10810">
          <rect width="48" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
